let button_template = `<i class="{{icon}}" aria-hidden="true" data-toggle="tooltip"></i>
{{text}}`;

import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';

    export default Marionette.View.extend({
        tagName: 'button',
        className: 'btn btn-default btn-sm',
        template: Handlebars.compile(button_template),
        events: {
            'click': function () {
                var action = this.getOption('action');
                if (action.call) return action();
                console.warn('No action configured for this button');
            }
        },
        templateContext: function() { 
            return {
                icon: this.getOption('icon'),
                text: this.getOption('text')
            };
        },
        onRender: function() {
            if ( this.getOption('primary') ) {
                this.$el.removeClass('btn-default');
                this.$el.addClass('btn-primary');
            }
            this.$el.tooltip({
                delay: { show: 500, hide: 100 }
            });
            if ( this.enabled && this.enabled == true ) {
                this.enable();
            } else if ( this.enabled && this.enabled == false ) {
                this.disable();
            }
        },
        enable: function() {
            this.$el.prop('disabled', false);
            this.$el.css('cursor', 'pointer');
            if (this.enabled_tooltip) this.set_tooltip_title(this.enabled_tooltip);
        },
        disable: function() {
            this.$el.prop('disabled', true);
            this.$el.css('cursor', 'not-allowed');
            if (this.disabled_tooltip) this.set_tooltip_title(this.disabled_tooltip);
        },
        set_tooltip_title: function(title){
            this._parent.$el.attr('title', title)
                // Allows dynamic setting of a bootstrap tooltip
                .tooltip('fixTitle');
        },
    });

